
<div class="wrapper-calendar flex my-gap-16">

    <ng-icon 
        class="cursor-pointer"
        name="heroCalendarDateRange"
        size="20px"
        (click)="picker.open()"
    ></ng-icon>

    <div class="wrapper__picker">
        <mat-date-range-input [formGroup]="form()" [rangePicker]="picker">
            <input matStartDate placeholder="Data inicial" formControlName="startDate">
            <input matEndDate placeholder="Data final" formControlName="endDate">
        </mat-date-range-input>
        
        <mat-date-range-picker #picker></mat-date-range-picker>
    </div>
</div>